<template>
	<div class="pa-5">
    <v-skeleton-loader
      class="mx-auto"
      v-if="!data"
      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
    ></v-skeleton-loader>
		<v-card class="elevation-10" shaped v-else>
			<v-card-title>
        <div>บทความทั้งหมด</div>
        <v-spacer></v-spacer>
        <v-btn color="success" to="/km/create">เขียนบทความ</v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-row>
          <v-col md="6">
            <v-select 
              dense 
              solo 
              :items="km_groups" 
              item-text="group_th" 
              item-value="id" 
              label="ประเภทบทความ"
              @change="group_change"
            ></v-select>
          </v-col>
          <v-col md="6">
            <v-text-field v-model="term" dense solo prepend-inner-icon="mdi-magnify" label="ค้นหา" @input="search_change"></v-text-field>
          </v-col>
        </v-row>    
      </v-card-text>
      <v-card-text class="pa-0">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>ชื่อบทความ</th>
                <th>ประเภท</th>
                <th>ผู้เขียน</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody v-if="data.data.length > 0">
              <tr v-for="item in data.data" :key="item.id">
                <td>{{ item.topic }}</td>
                <td class="text-truncate">{{ item.group.group_th }}</td>
                <td class="text-truncate">{{ item.owner.display_name }}</td>
                <td>
                  <v-menu offset-y transition="fade-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                    </template>
                    <v-list>
                      <v-list-item :to="`/km/${item.id}/edit`">
                        <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                        <v-list-item-title>แก้ไข</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="confirm_delete_data(item.id)">
                        <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
                        <v-list-item-title>ลบ</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <v-subheader>---ไม่พบแบบฟอร์มในระบบ---</v-subheader>
            </tbody>
          </template>
        </v-simple-table>
        <v-pagination
          class="py-5"
          v-model="page"
          :length="data.last_page"
          @input="select_page"
        ></v-pagination>
      </v-card-text>
		</v-card>
    <ConfirmDialog
      message="คุณต้องการลบบทความนี้ใช่หรือไม่?"
      color="error"
      :dialog="confirm_delete"
      @confirm="delete_data"
    />
	</div>
</template>

<script>
import confirmDialog from '@/components/ConfirmDialog';
import _ from 'lodash';

export default {
  components: {
    ConfirmDialog: confirmDialog
  },
	data: () => ({
    data: null,
    page: 1,
    term: '',
    type: '',
    confirm_delete: false
  }),
  computed: {
    km_groups() { 
      return [ { id: '', group_th: 'ทั้งหมด' }, ...this.$store.state.km.km_groups ]
    }
  },
	mounted() {
    this.get_data('', '', this.page);
  },
  methods: {
    get_data(term, type, page) {
      this.$store.dispatch('km/list', {
        term: term,
        type: type,
        page: page
      }).then(data => this.data = data);
    },
    delete_data(e) {
      if(e) {
        this.$store.dispatch('km/delete', this.delete_selected).then(res => {
          this.get_data('', '', 1);
          this.confirm_delete = false;
          this.$store.commit('SHOW_SNACKBAR', {
            color: 'success',
            message: res.message
          });
        });
      } else {
        this.confirm_delete = false;
      }
      // if(e) {
      // } else {
      //   console.log('x'.e);
      // }
    },
    confirm_delete_data(id) {
      this.confirm_delete = true;
      this.delete_selected = id;
    },
    select_page(e) {
      this.page = e;
      this.get_data(this.term, this.type, e);
    },
    group_change(val) {
      this.type = val;
      this.get_data(this.term, val, 1);
    },
    search_change: _.debounce(function(e) {
      this.page = 1;
			this.get_data(e, this.type, 1);
		}),
  }
}
</script>